// Customize the Smoobu calendar widget
function customizeCalendarWidget() {
  let singleWidgets = document.querySelectorAll('.singleCalendarWidget');
  singleWidgets.forEach(widget => widget.removeAttribute('style'));

  let tableCells = document.querySelectorAll('.singleCalendarWidget th, .singleCalendarWidget td');
  tableCells.forEach(cell => cell.removeAttribute('style'));

  let logoLink = document.querySelector('.multiCalendarWidget .logo a');
  if (logoLink) {
    logoLink.setAttribute('rel', 'noopener noreferrer');
  }
}

// Create a MutationObserver to watch for changes in the DOM
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    // Check if the calendar widget is present in the DOM
    if (document.querySelector('.calendarWidget .calendarContent div')) {
      customizeCalendarWidget();
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
});
